
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class AppAccordion extends Vue {

    isClosed: boolean = true;


    get accordionClasses() {
        return {
            'App-Accordion': true,
            'App-Accordion--IsClosed': this.isClosed,
            'App-Accordion--IsOpened': !this.isClosed
        };
    }

    get headerClasses() {
        return {
            'App-Accordion__Header': true,
        }
    }

    get togglerClasses() {
        return  {
            'App-Accordion__Arrow': true,
            'App-Accordion__Arrow--Up': this.isClosed,
            'App-Accordion__Arrow--Down': !this.isClosed,
        }
    }

    toggleAccordion() {
        this.isClosed = !this.isClosed;
    }

}
